<template lang="pug">
  div
    b-alert(:show='true' :variant='tipo')
      | {{mensaje}}
    b-form(@submit='onSubmit' @reset='onReset')
      b-card(v-if="this.add == true")
        template(#header='')
          h6.mb-0 Modificar Respuesta
        b-card-text
          div
            .form-group.row
              b-form-group#input-group-1.col-sm-1.col-form-label(label='RUC:' label-for='input-ruc')
              .col-sm-3
                b-form-input#input-ruc(v-model='propuesta.ruc' :disabled='this.disabledEnviado' @blur.native ='getDatosProveedor(propuesta.ruc)')
              span.ml-auto(style='color: red;') *
              b-form-group#input-group-2.col-form-label(label='Razon Social:' label-for='input-razon-social')
              .col-sm-4
                b-form-input#input-razon-social(v-model='propuesta.razon_social' :disabled='this.disabledEnviado'  required='')
            .form-group.row
              span(style='color: red;') *
              b-form-group#input-group-3.col-sm-1.col-form-label(label='Correo:' label-for='input-correo')
              .col-sm-7
                b-form-input#input-correo(v-model='propuesta.email' :disabled='this.disabledEnviado'  type='email' required='')
            .form-group.row
              span(style='color: red;') *
              b-form-group#input-group-3.col-sm-1.col-form-label(label='Respuesta:' label-for='input-propuesta')
              .col-sm-11
                vue-editor(
                  :disabled='this.disabledEnviado'
                  v-model='propuesta.descripcion_propuesta'
                  :editorToolbar="customToolbar"
                )
            br
            .form-group.row(v-if = '!this.disabledEnviado')
              b-form-group#input-group-12.col-sm-2.col-form-label(label='Adjuntar Documento:' label-for='input-documento')
              .col-sm
                .row
                  .col
                    b-form-file#file-default(
                      v-model= 'archivo'
                      placeholder="Seleccionar Archivo"
                      accept=".zip, .rar, .tar, application/pdf,application/x-zip-compressed"
                    )
                  .col
                    button.btn.btn-primary.border-top(
                      :disabled='this.archivo == null || cargaArchivo '
                      @click.prevent='cargarArchivo()'
                    ) {{cargaArchivo ? 'Subiendo Archivo...' : 'Subir Archivo'}}

            table.table.table-bordered.table-condensed.table-striped.table-hover(v-if = 'archivoList.length > 0')
              thead
                tr
                  th.text-center.w-25 Nombre
                  th.text-center.w-25 Fecha Adjunto
                  th.text-center.w-25 Acciones
              tbody()
                tr( v-for='(row,index) in archivoList')
                  td.text-center {{row.name}}
                  td.text-center {{row.lastModifiedDate ? convertDate(row.lastModifiedDate) : row.fechaArchivo}}
                  td.text-center
                    .btn-group
                      b-dropdown.m-md-1(text='Acciones' )
                        b-dropdown-item( @click.prevent='obtenerArchivo(row)') Descargar
                        b-dropdown-item(v-if="!disabledEnviado" @click.prevent='borrarArchivo(row)') Borrar

            button.btn.btn-primary(type='submit' v-if='!this.disabledEnviado' @click='grabarBorrador = true') Guardar
            div(v-if='!this.disabledEnviado').float-right.m-md-1
              button.btn.btn-danger.m-md-1(type='reset' v-if='!this.disabledEnviado' @click='retirar = true') Retirar Respuesta
              button.btn.btn-danger.m-1(type='submit'  @click='grabarBorrador = false' variant='primary') Confirmar y Enviar
    button.btn.btn-warning.float-right.m-md-1(v-if="this.disabledEnviado && !this.eliminado" @click="reabrir = true ;mostrarModal(\"modificar\")\n") Modificar


    modal(:title="modalTitulo" :texto="modalTexto"
      :modalShow="modalShow"
      :button-action-name="modalBoton"
      @confirmed='confirmarAccionModal()'
      @close="cerrarAccionModal()"
      :isPublic="true"
    )

</template>

<script>

import {VueEditor} from "vue2-editor";

import {HTTP} from "../http";
import functions from '../mixins/functions';
import Modal from "../components/Modal"


export default {
  name: "ModificarRespuesta",
  mixins: [functions],
  components: {
    Modal,
    VueEditor
  },

  data() {
    return {
      add: Boolean,
      eliminado: false,
      propuesta: {},
      solicitudInformacion: {},
      controlDuplicado: {},
      listaPropuestas: {},
      archivoList: [],
      archivo: null,
      descripcion_propuesta : "",
      modalShow: false,
      modalTitulo: "",
      modalTexto: "",
      modalBoton: "",
      retirar: false,
      reabrir: false,
      cargaArchivo: false,
      datosProveedor: {},
      grabarBorrador: Boolean,
      rfi_hash: null,
      mensaje: "",
      tipo: "",
      disabledEnviado: false,
      requiredFields: [
          'descripcion_propuesta'
        ],
      customToolbar: [[{
        header: [false, 1, 2, 3, 4, 5, 6]
      }], ["bold", "italic", "underline", "strike"], // toggled buttons
        [{
          align: ""
        }, {
          align: "center"
        }, {
          align: "right"
        }, {
          align: "justify"
        }], ["blockquote", "code-block"], [{
          list: "ordered"
        }, {
          list: "bullet"
        }, {
          list: "check"
        }], [{
          indent: "-1"
        }, {
          indent: "+1"
        }], // outdent/indent
        [{
          color: []
        }, {
          background: []
        }], // dropdown with defaults from theme
        ["clean"] // remove formatting button
      ],
    }
  },
  async created(){
    this.activeSpinner();

    this.add = true;
    this.grabarBorrador= false;
    this.rfi_hash = this.$route.query.id;
    this.propuesta = (await HTTP.get('/respuesta/get/'+this.rfi_hash)).data
    this.solicitudInformacion = (await HTTP.get('/solicitudInformacion/',{ params: {solicitudId: this.propuesta.rfi_id}})).data

    await this.getArchivos(); // Se actualiza la lista de archivos
    if (this.propuesta.estado_codigo == 'BORRADOR'){
      this.disabledEnviado = false
      this.tipo = 'warning'
      this.mensaje = "Atencion: Esta respuesta se encuentra en estado BORRADOR. Debe realizar la accion de enviar para confirmarla."
    } else if(this.propuesta.estado_codigo == 'ENVIADO'){
      this.tipo = 'success'
      this.mensaje = "Esta respuesta se encuentra en estado ENVIADO. Para volver a enviarlo debe la realizar la accion de modificar."
      this.disabledEnviado = true
    } else if(this.propuesta.estado_codigo == 'RETIRADO') {
      this.tipo = 'danger'
      this.mensaje = "Esta respuesta ha sido RETIRADA."
      this.disabledEnviado = true
      this.eliminado = true
    }
    this.desactiveSpinner();


  },

  methods: {
    onSubmit(event) {
      if(this.grabarBorrador == true){
        this.mostrarModal("grabar")
      }else if(this.grabarBorrador == false) {
        this.mostrarModal("enviar")
      }
      event.preventDefault()
    },

    onReset(event) {
      this.mostrarModal("retirar")
      event.preventDefault()
    },

    mostrarModal(accion){
      this.modalShow = !this.modalShow
      if(accion =="enviar"){
        this.modalTexto = "Desea enviar y publicar la Respuesta?"
        this.modalTitulo = "Confirmar envio de Respuesta"
        this.modalBoton = "Enviar"
      } else if(accion =="grabar"){
        this.modalTexto = "Desea grabar los datos de la Respuesta?"
        this.modalTitulo = "Confirmar grabacion de Respuesta"
        this.modalBoton = "Grabar"
      } else if(accion =="retirar"){
        this.modalTexto = "Desea retirar la Respuesta?"
        this.modalTitulo = "Confirmar retiro de Respuesta"
        this.modalBoton = "Retirar"
      }else if(accion =="modificar"){
        this.modalTexto = "Desea retirar y volver a modificar la Respuesta?"
        this.modalTitulo = "Confirmar retiro y modificacion de Respuesta"
        this.modalBoton = "Modificar"
      }
    },

    confirmarAccionModal() {
      this.modalShow = !this.modalShow
      if(this.grabarBorrador  == true || this.reabrir == true){
        this.modificar(this.propuesta, "BORRADOR")
      }else if(this.retirar == true){
        this.modificar(this.propuesta, "RETIRADO")
      }else if(this.grabarBorrador == false) {
        this.modificar(this.propuesta, "ENVIADO")
      }
    },

    cerrarAccionModal() {
      this.modalShow = !this.modalShow;
      this.grabarBorrador = false ;
      this.retirar = false;
      this.reabrir = false;
    },

    getDatosProveedor:async function(ruc) {
      this.propuesta.razon_social = null
      this.propuesta.email = null
      this.propuesta.proveedor_id = null

      this.datosProveedor = (await HTTP.get('/invitado/getProveedor/'+ruc)).data

      this.propuesta.razon_social = this.datosProveedor.razon_social
      this.propuesta.email = this.datosProveedor.email
      this.propuesta.proveedor_id = this.datosProveedor.id

      this.add = false
      this.$nextTick(()=>{
        this.add = true
      })
    },

    modificar: async function (instance, estado) {
      this.controlDuplicado.email = instance.email
      this.controlDuplicado.ruc = instance.ruc
      this.controlDuplicado.rfi_id = instance.rfi_id
      this.propuesta.rfi_tema = this.solicitudInformacion.tema
      if(!this._checkRequired(instance, this.requiredFields)){
        window.scrollTo(0, 0);
        this.$root.$emit('showNotificationWarning', {mensaje: 'Debe ingresar la Respuesta'});

      } else {
        instance.archivos = []
        this.archivoList.forEach(archivo => {
          let fileToSave = {
            nombre_archivo: archivo.name,
            type: archivo.type,
            size: archivo.size,
            tmpFilePath: archivo.tmpFilePath
          }
          instance.archivos.push(fileToSave)
        })
        try {
          instance.estado_codigo = estado
          await (HTTP.post('/respuesta/modificar', instance));
          this.$root.$emit('showNotificationSuccess', {mensaje: 'Se ha modificado la Respuesta'});
          window.scrollTo(0, 0);
          this.$router.go(this.$router.currentRoute)
        } catch (error) {
          console.log(error);
          this.$root.$emit('showNotificationError', {mensaje: 'Ocurrio un error al grabar la Respuesta. '+ error.response.data});
          window.scrollTo(0, 0);
        }
      }
    },
    convertDate: function(fecha) {
      if(fecha){
        let date = JSON.stringify(fecha)
        date = date.slice(1,11)
        return date
      }
      return null
    },


    async getArchivos() {
      this.archivoList = (await HTTP.get('/archivo/listarDocumentosPropuesta', {params: {propuestaId: this.propuesta.id}})).data;

    },
    cargarArchivo: function () {
      let formData = new FormData()
      formData.append('archivo', this.archivo)
      this.cargaArchivo = true;
      HTTP.post('/archivo/subir', formData, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'multipart/form-data'
        },
      }).then(result => {
        this.archivo.tmpFilePath = result.data.tmpFilePath
        this.archivoList.push(this.archivo)
        this.$root.$emit('showNotificationSuccess', {mensaje: 'Archivo recibido correctamente'});
        this.archivo = null
      }).catch(error => {
        this.$root.$emit('showNotificationError', {mensaje: 'Ocurrio un error al subir el archivo. ' + error.response.data});
      }).finally(() => {
        this.cargaArchivo = false;
      })
    },
    obtenerArchivo(instance) {
      HTTP.get('/archivo/obtenerPropuestaArchivo', {params: {documentoId: instance.id}, responseType: 'blob'})
          .then(result => {
            this.handleResponseArchivo(result.data, instance.name)
          })
          .catch(error => {
            this.$root.$emit('showNotificationError', {mensaje: 'Ocurrio un error al Obtener el archivo. ' + error.response.data});
          })
    },
    borrarArchivo: function (instance) {
      // this.$delete(this.archivoList, index)
      HTTP.delete('/archivo/eliminarDocumentoPropuesta', {params: {documentoId: instance.id}})
          .then(async result => {
            console.log(result)
            window.scrollTo(0,0);
            this.$root.$emit('showNotificationSuccess', {mensaje: 'Archivo eliminado correctamente'});
            await this.getArchivos(); // Se actualiza la lista de archivos
          })
          .catch(error => {
            console.log(error)
            window.scrollTo(0,0);
            this.$root.$emit('showNotificationError', {mensaje: 'Ocurrio un error al Borrar el archivo'});
          })
      window.scrollTo(0,0);

    },
    handleResponseArchivo(blobData, name) {
      let fileURL = window.URL.createObjectURL(blobData);
      let fileLink = document.createElement("a");
      fileLink.href = fileURL;
      fileLink.setAttribute("download", `${name}`);
      document.body.appendChild(fileLink);
      fileLink.click();
      fileLink.remove();
    }
  }
}
</script>

<style scoped>

</style>
